import React, { useState, useEffect } from "react";
import CreateVariantFromTemplateModal from "./CreateVariantFromTemplateModal";

const EVENT_NAME = "openCreateVariantFromTemplateModal";

const CreateVariantFromTemplateModalWrapper = ({
  website,
  cta,
  createPath,
  currentUser,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [templateData, setTemplateData] = useState(null);

  useEffect(() => {
    const handleOpen = (event) => {
      if (event.detail?.templateData) {
        setTemplateData(event.detail.templateData);
        setIsOpen(true);
      }
    };

    document.addEventListener(EVENT_NAME, handleOpen);
    return () => document.removeEventListener(EVENT_NAME, handleOpen);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    setTemplateData(null);
  };

  return (
    <CreateVariantFromTemplateModal
      isOpen={isOpen}
      onClose={handleClose}
      templateData={templateData}
      website={website}
      cta={cta}
      createPath={createPath}
      currentUser={currentUser}
    />
  );
};

export default CreateVariantFromTemplateModalWrapper;
